import { supabase } from "@/integrations/supabase/client";
import { getMergeConfig } from "@/config/mergeConfigRegistry";
import { generateSelectFieldsFromConfig } from "@/utils/mergeConfigUtils";

export const fetchCompaniesByIds = async (ids: string[]) => {
	if (ids.length === 0) return [];
	
	// Get the appropriate select fields from the merge configuration
	const mergeConfig = getMergeConfig("companies");
	const selectFields = mergeConfig ? generateSelectFieldsFromConfig(mergeConfig) : "*";
	
	//console.log(`🔍 Fetching companies with fields: ${selectFields}`);
	
	const { data, error } = await supabase
		.from('companies')
		.select(selectFields)
		.in('id', ids);
	
	if (error) {
		console.error('Error fetching companies:', error);
		throw error;
	}
	
	return data || [];
};